import { combineReducers } from 'redux';
import trackingMethods from './trackingMethods';
import trackingMethodLocations from './trackingMethodLocations';

export default combineReducers({
  trackingMethods,
  trackingMethodLocations
});
